<template>
  <el-dialog
    class="dialog-form"
    append-to-body
    :visible.sync="visibleCategorySub"
    title="Thêm nhanh loại sản phẩm"
    width="600px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="closePopup"
  >
    <validation-observer ref="observerCategorySub" id="observerCategorySub">
      <form>
        <LayoutFieldSet type="block" >
          <LayoutField type="block" :required="true">
            <template #label>Tên loại sản phẩm</template>
            <template #input>
              <BaseInput
                placeholder="Nhập tên loại sản phẩm"
                v-model="name"
                name="Loại sản phẩm"
                :rules="'required|lBetween:1,255|CHECK_HTML'"
              />
            </template>
          </LayoutField>
        </LayoutFieldSet>

        <LayoutFieldSet type="block" >
          <LayoutField type="block" >
            <template #label>Thuộc danh mục</template>
            <template #input>
              <BaseSelect
                :options="listCategory"
                label="name"
                v-model="category.name"
                :disabled="true"
              />
            </template>
          </LayoutField>
        </LayoutFieldSet>
      </form>
    </validation-observer>

    <template slot="footer">
      <el-button type="text" @click="closePopup()"> Thoát </el-button>
      <el-button
        :loading="btnLoading"
        type="primary"
        @click="btnConfirmAddCategorySub()"
      >
        Hoàn tất
      </el-button>
    </template>
  </el-dialog>
</template>

<script>
import { CategoryService } from "@/services/nextshop/category.service";

export default {
  props: {
    isPopup: {
      type: Boolean,
      default: false,
    },

    category: {
      type: Object
    },

    listCategory: {
      type: Array,
      default: []
    }
  },

  data() {
    return {
      btnLoading: false,
      visibleCategorySub: false,
      mcBusinessCode: '',
      name: '',
    };
  },

  created() {
    this.getDataMerchant();
  },

  methods: {
    async getDataMerchant() {
      try {
        const response = await SettingService.getDataMerchant()
        if (response.success) {
          this.mcBusinessCode = response.data.merchant.businessFieldCode
        }
      } catch (error) {
        console.log();
      }
    },

    async btnConfirmAddCategorySub() {
      try {
        await this.$refs.observerCategorySub.validate();

        let el = document.querySelector("#observerCategorySub .is-invalid");
        if (el) {
          el.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
          el.focus();
        } else {
          this.btnLoading = true;
          const req = {
            description: "",
            imageUrl: "",
            name: this.name.trim(),
            parentId: this.category.id,
          };
          await CategoryService.addCate(req).then(async (res) => {
            if (res.success) {
              // const params = await this.getListCategory();
              this.btnLoading = false;
              this.$emit('getValue', res.data)
              this.name = ''
            }
          });
        }
      } catch (error) {
        console.log(error);
        this.$message.error("Thêm mới đơn vị lỗi, vui lòng thử lại");
        this.btnLoading = false;
      }
    },

    closePopup() {
      this.name = ''
      this.$refs.observerCategorySub.refs[`Loại sản phẩm`].errors = [];
      this.visibleCategorySub = false;
      this.$emit("getValue", null);
    },
  },

  watch: {
    isPopup: {
      handler: function () {
        this.visibleCategorySub = this.isPopup;
      },
    },
  },
};
</script>

<style>
</style>